import { apiRequest, deleteResource, getResource } from "../api/http";

// Podcasts reuse the show/season/episode endpoints for details, seasons and episodes.
export {
  getTvShow as getPodcast,
  deleteSeason as deletePodcastSeason,
  getEpisodeList as getPodcastEpisodeList,
  getEpisode as getPodcastEpisode,
  updateEpisode as updatePodcastEpisode,
  deleteEpisode as deletePodcastEpisode,
  createEpisode as createPodcastEpisode,
  updateEpisodeMedia as updatePodcastEpisodeMedia,
} from "./shows";

export function getPodcastList() {
  return getResource("/api/podcast/get-all-podcast-list");
}

export function getPodcastSeasonList(podcast_id) {
  return getResource(`/api/podcast/get-seasons-of-a-podcast/${podcast_id}`);
}

export function updatePodcast(obj, podcast_id) {
  return apiRequest("put", `/api/podcast/update-podcast/${podcast_id}`, {
    data: obj,
  });
}

export function deletePodcast(podcast_id) {
  return deleteResource(`/api/podcast/delete-podcast/${podcast_id}`);
}

export function createPodcast(generalInfo) {
  return apiRequest("post", "/api/podcast/create-podcast", {
    data: generalInfo,
    rethrow: true,
  });
}

export function createPodcastSeason(podcast_id, generalInfo) {
  return apiRequest(
    "post",
    `/api/seasons/create-season-of-podcast/${podcast_id}`,
    { data: generalInfo, rethrow: true }
  );
}
